export function getStoredYear(storageKey: string): number {
    return parseInt(localStorage.getItem(storageKey) ?? '') || new Date().getFullYear();
}

export function populateYearSelect(
    availableYears: number[],
    selectedYear: number,
    storageKey: string,
    onYearChange: (year: number) => void
): void {
    const select = document.getElementById('year-switcher') as HTMLSelectElement | null;
    if (!select) {
        return;
    }
    availableYears.forEach(year => {
        const option = document.createElement('option');
        option.value = year.toString();
        option.textContent = year.toString();
        option.selected = year === selectedYear;
        select.appendChild(option);
    });
    select.addEventListener('change', () => {
        const year = parseInt(select.value);
        localStorage.setItem(storageKey, year.toString());
        onYearChange(year);
    });
}
